import { ILocalizedName } from 'src/interfaces/ILocalizedName';

export interface HelperlinkData {
    id: number;
    text: ILocalizedName;
    link: ILocalizedName;
    appId: number;
    subAppId?: number;
}

export interface IAppLayouts {
    id: number;
    name: string;
    enabled: boolean;
    allowAnonymous: boolean;
    color: string;
    icon: number;
    nameFr: string;
    nameEn: string;
    url?: string;
}

export interface ISubAppLayouts {
    id: number;
    name: string;
    enabled: boolean;
    appId: number;
    icon: number;
    nameFr: string;
    nameEn: string;
    url: string;
}

export interface IlayoutGroup {
    nameFr: string;
    nameEn: string;
}

export interface IApps extends IAppLayouts {
    appsLayoutGroups: IlayoutGroup;
    subApps?: ISubAppLayouts[];
}

export interface initialDataDto {
    listOfApps: IApps[];
    listOfLinks: HelperlinkData[];
}

export enum LayoutName {
    sse = 'Health, safety and environment',
    rh = 'Human resources',
    proj = 'Project execution',
}
